// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card {
  margin: auto;
  width: 96%;
  margin-top: 2%;
  margin-bottom: 3%;
}

h1 {
  font-size: 1.5rem;
}

.cople-row {
  background-color: antiquewhite;
}

mat-card.mat-card.mat-focus-indicator {
  box-shadow: 4px -3px 7px 4px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

input {
  max-width: 100%;
  width: 100%;
  font-size: 13px;
  max-height: 35px;
  height: 35px;
  text-align: center;
  margin-top: 2px;
  border-radius: 7px;
  border-color: #6c757d;
  border-style: double;
  display: flex;
}

mat-grid-list {
  display: flex;
  direction: rtl;
}

.title {
  margin-bottom: -15px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  width: 97.5%;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

mat-radio-group {
  display: flex;
  margin-right: auto;
}

:host ::ng-deep .mat-radio-label-content {
  padding-right: 10px;
}

.buttons {
  margin-right: auto;
  direction: ltr;
  margin-left: 10px;
}

.button-back {
  margin-left: 10px;
}

.text-right-item {
  font-size: smaller;
}

::ng-deep .mat-grid-tile .mat-figure {
  align-items: flex-start !important;
  justify-content: right !important;
  margin-top: 15px !important;
  margin-right: 15px !important;
}

mat-radio-button {
  margin-left: 20px;
}

img {
  width: 100px;
  height: 100px;
}

.img2 {
  width: 400px;
  height: 400px;
}

.request-card {
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
  padding: 15px;
  border-radius: 5px;
  background-color: white;
  margin: 20px;
}
.request-card .right-side {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 20px;
  direction: rtl;
  text-align: right;
}
.request-card .right-side div {
  align-items: baseline;
  display: inline;
  padding: 10px;
}
.request-card .left-side {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 25%;
  justify-content: center;
  display: flex;
  border-right: 4px dashed #eee;
}
.request-card .left-side div {
  display: inline;
}
.request-card .left-side div * {
  margin-right: 5px;
}

p {
  margin-top: 10px;
}

.text-item {
  font-size: 13px;
}

.btn {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 105px;
  border: 2px solid #eee;
}

.icon-card {
  margin: auto;
  margin-top: 1px;
  margin-left: 8px;
  font-size: 20px;
}

.field-header {
  margin-right: auto;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/features/identification/identification-info/identification-info.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/identification/identification-info/identification-info.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;ACCF;;ADCA;EACE,iBAAA;ACEF;;ADAA;EACE,8BAAA;ACGF;;ADDA;EACE,yHAAA;ACIF;;ADAA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;ACGF;;ADAA;EACE,aAAA;EACA,cAAA;ACGF;;ADDA;EACE,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;ACIF;;ADFA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACKF;;ADHA;EACE,aAAA;EACA,kBAAA;ACMF;;ADJA;EACE,mBAAA;ACOF;;ADJA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;ACOF;;ADLA;EACE,iBAAA;ACQF;;ADNA;EACE,kBAAA;ACSF;;ADNA;EACE,kCAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;ACSF;;ADPA;EACE,iBAAA;ACUF;;ADRA;EACE,YAAA;EACA,aAAA;ACWF;;ADTA;EACE,YAAA;EACA,aAAA;ACYF;;ADRA;EACE,uGAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;ACWF;ADVE;EAME,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACOJ;ADlBI;EACE,qBAAA;EACA,eAAA;EACA,aAAA;ACoBN;ADTE;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;ACWJ;ADVI;EACE,eAAA;ACYN;ADXM;EACE,iBAAA;ACaR;;ADPA;EACE,gBAAA;ACUF;;ADRA;EACE,eAAA;ACWF;;ADRA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;ACWF;;ADTA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACYA;;ADTA;EACE,kBAAA;EACA,iBAAA;ACYF","sourcesContent":["mat-card {\r\n  margin: auto;\r\n  width: 96%;\r\n  margin-top: 2%;\r\n  margin-bottom: 3%;\r\n}\r\nh1{\r\n  font-size: 1.5rem;\r\n}\r\n.cople-row{\r\n  background-color: antiquewhite;\r\n}\r\nmat-card.mat-card.mat-focus-indicator {\r\n  box-shadow: 4px -3px 7px 4px rgb(0 0 0 / 20%),\r\n    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);\r\n}\r\n\r\ninput {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  font-size: 13px;\r\n  max-height: 35px;\r\n  height: 35px;\r\n  text-align: center;\r\n  margin-top: 2px;\r\n  border-radius: 7px;\r\n  border-color: #6c757d;\r\n  border-style: double;\r\n  display: flex;\r\n}\r\n\r\nmat-grid-list {\r\n  display: flex;\r\n  direction: rtl;\r\n}\r\n.title {\r\n  margin-bottom: -15px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 97.5%;\r\n}\r\n.parent-both {\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}\r\nmat-radio-group {\r\n  display: flex;\r\n  margin-right: auto;\r\n}\r\n:host ::ng-deep .mat-radio-label-content {\r\n  padding-right: 10px;\r\n}\r\n\r\n.buttons{\r\n  margin-right: auto;\r\n  direction: ltr;\r\n  margin-left: 10px;\r\n}\r\n.button-back{\r\n  margin-left: 10px;\r\n}\r\n.text-right-item {\r\n  font-size: smaller;\r\n}\r\n\r\n::ng-deep .mat-grid-tile .mat-figure {\r\n  align-items: flex-start !important;\r\n  justify-content: right !important;\r\n  margin-top: 15px !important;\r\n  margin-right: 15px !important;\r\n}\r\nmat-radio-button {\r\n  margin-left: 20px;\r\n}\r\nimg {\r\n  width: 100px;\r\n  height: 100px;\r\n}\r\n.img2{\r\n  width: 400px;\r\n  height: 400px;\r\n}\r\n\r\n\r\n.request-card {\r\n  box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  background-color: white;\r\n  margin: 20px;\r\n  .right-side {\r\n    div {\r\n      align-items: baseline;\r\n      display: inline;\r\n      padding: 10px;\r\n    }\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    padding-left: 20px;\r\n    direction: rtl;\r\n    text-align: right;\r\n\r\n  }\r\n  .left-side {\r\n    flex: 1 1 100%;\r\n    box-sizing: border-box;\r\n    max-width: 25%;\r\n    justify-content: center;\r\n    display: flex;\r\n    border-right: 4px dashed #eee;\r\n    div {\r\n      display: inline;\r\n      * {\r\n        margin-right: 5px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\np{\r\n  margin-top: 10px;\r\n}\r\n.text-item{\r\n  font-size: 13px;\r\n}\r\n\r\n.btn{\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 105px;\r\n  border: 2px solid #eee;\r\n}\r\n.icon-card{\r\nmargin: auto;\r\nmargin-top: 1px;\r\nmargin-left: 8px;\r\nfont-size: 20px;\r\n}\r\n\r\n.field-header{\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n\r\n","mat-card {\n  margin: auto;\n  width: 96%;\n  margin-top: 2%;\n  margin-bottom: 3%;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\n.cople-row {\n  background-color: antiquewhite;\n}\n\nmat-card.mat-card.mat-focus-indicator {\n  box-shadow: 4px -3px 7px 4px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n}\n\ninput {\n  max-width: 100%;\n  width: 100%;\n  font-size: 13px;\n  max-height: 35px;\n  height: 35px;\n  text-align: center;\n  margin-top: 2px;\n  border-radius: 7px;\n  border-color: #6c757d;\n  border-style: double;\n  display: flex;\n}\n\nmat-grid-list {\n  display: flex;\n  direction: rtl;\n}\n\n.title {\n  margin-bottom: -15px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  width: 97.5%;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\nmat-radio-group {\n  display: flex;\n  margin-right: auto;\n}\n\n:host ::ng-deep .mat-radio-label-content {\n  padding-right: 10px;\n}\n\n.buttons {\n  margin-right: auto;\n  direction: ltr;\n  margin-left: 10px;\n}\n\n.button-back {\n  margin-left: 10px;\n}\n\n.text-right-item {\n  font-size: smaller;\n}\n\n::ng-deep .mat-grid-tile .mat-figure {\n  align-items: flex-start !important;\n  justify-content: right !important;\n  margin-top: 15px !important;\n  margin-right: 15px !important;\n}\n\nmat-radio-button {\n  margin-left: 20px;\n}\n\nimg {\n  width: 100px;\n  height: 100px;\n}\n\n.img2 {\n  width: 400px;\n  height: 400px;\n}\n\n.request-card {\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n  padding: 15px;\n  border-radius: 5px;\n  background-color: white;\n  margin: 20px;\n}\n.request-card .right-side {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 20px;\n  direction: rtl;\n  text-align: right;\n}\n.request-card .right-side div {\n  align-items: baseline;\n  display: inline;\n  padding: 10px;\n}\n.request-card .left-side {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  max-width: 25%;\n  justify-content: center;\n  display: flex;\n  border-right: 4px dashed #eee;\n}\n.request-card .left-side div {\n  display: inline;\n}\n.request-card .left-side div * {\n  margin-right: 5px;\n}\n\np {\n  margin-top: 10px;\n}\n\n.text-item {\n  font-size: 13px;\n}\n\n.btn {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 105px;\n  border: 2px solid #eee;\n}\n\n.icon-card {\n  margin: auto;\n  margin-top: 1px;\n  margin-left: 8px;\n  font-size: 20px;\n}\n\n.field-header {\n  margin-right: auto;\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
